<template>
  <div>
    <div class="trophy-challenge-registration-contact">
      <!--            <h2 class="form-title"></h2>-->

      <div class="basicForm__row basicForm__item">
        <label for="executionCompany">Realizační firma</label>
        <input type="text" class="button view-bordered" id="executionCompany" v-model="executionCompany">
      </div>
      <div class="error-message" v-if="getFieldError('executionCompany')">
        <p>{{ getFieldError('executionCompany') }}</p>
      </div>

      <div class="basicForm__row basicForm__item">
        <label for="designer">Projektant</label>
        <input type="text" class="button view-bordered" id="designer" v-model="designer">
      </div>
      <div class="error-message" v-if="getFieldError('designer')">
        <p>{{ getFieldError('designer') }}</p>
      </div>

      <div class="basicForm__row basicForm__item">
        <label for="architect">Architekt</label>
        <input type="text" class="button view-bordered" id="architect" v-model="architect">
      </div>
      <div class="error-message" v-if="getFieldError('architect')">
        <p>{{ getFieldError('architect') }}</p>
      </div>

      <div class="basicForm__row basicForm__item">
        <label for="generalContractor">Generální dodavatel</label>
        <input type="text" class="button view-bordered" id="generalContractor" v-model="generalContractor">
      </div>
      <div class="error-message" v-if="getFieldError('generalContractor')">
        <p>{{ getFieldError('generalContractor') }}</p>
      </div>

      <div class="basicForm__row basicForm__item">
        <label for="city">Město realizace projektu</label>
        <input type="text" class="button view-bordered" id="city" v-model="city">
      </div>
      <div class="error-message" v-if="getFieldError('city')">
        <p>{{ getFieldError('city') }}</p>
      </div>
    </div>
    <div class="trophy-challenge-registration-aboatProject">
      <h2 class="form-title">O vašem projektu</h2>

      <div class="basicForm__row basicForm__item">
        <label for="name">Pojmenujte váš projekt (názvem, pod kterým bude zobrazen na stránkách)</label>
        <input type="text" class="button view-bordered" id="name" v-model="name">
      </div>
      <div class="error-message" v-if="getFieldError('name')">
        <p>{{ getFieldError('name') }}</p>
      </div>

      <div class="basicForm__row basicForm__item">
        <label for="description">Prozraďte nám svůj příběh, proč chcete rekonstruovat.<br> Co vás k tomu vede a jaká je
          vaše představa o výsledné podobě proměny.</label>
        <textarea class="button view-bordered" id="description" v-model="description"></textarea>
      </div>
      <div class="error-message" v-if="getFieldError('description')">
        <p>{{ getFieldError('description') }}</p>
      </div>

      <trophy-challenge-file-upload section="list_photo" title="Fotka pro výpis (jpg, png)"/>
      <trophy-challenge-file-upload section="gallery" files-limit="5" title="Fotky pro galerii (jpg, png)"/>
      <div class="error-message" v-if="getFieldError('files')">
        <p>{{ getFieldError('files') }}</p>
      </div>
      <div class="checkboxes">
        <div class="basicForm__row basicForm__item">
          <label class="checkbox">
            <input type="checkbox" class="checkbox-native" v-model="rules">
            <span class="checkbox-control"></span>
            <span class="checkbox-label">
                souhlasím s <a href="https://www.rigips.cz/rekonstrukcni-vyzva/pravidla/" target="_blank" title="Podmínky soutěže">podmínkami soutěže</a>
            </span>
          </label>
        </div>
        <div class="error-message" v-if="getFieldError('rules')">
          <p>{{ getFieldError('rules') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';
import TrophyChallengeFileUpload from './FileUpload';

export default {
  name: 'TrophyChallengeRegistrationForm',
  components: {TrophyChallengeFileUpload},
  computed: {
    ...mapFields('trophyChallenge', [
      'form.data.executionCompany',
      'form.data.designer',
      'form.data.architect',
      'form.data.generalContractor',
      'form.data.city',
      'form.data.project.name',
      'form.data.project.description',
      'form.data.rules',
    ]),
    ...mapGetters('trophyChallenge', ['errors']),
  },
  methods: {
    getFieldError(field) {
      const error = find(this.errors, error => field === error.field);
      if (!isUndefined(error)) {
        return error.msg;
      }
      return null;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/trophy-challenge/Form.vue